module.exports = __webpack_public_path__ + "static/img/banner-1.27490e14.png";